module.exports = __webpack_public_path__ + "assets/img/32_635_big.79fdbbc2.jpg";